import React, { useState } from 'react'
import { Button, Modal } from 'antd'
import uke from '../img/UKE.jpg'
import nuritov from '../img/nuritov.jpg'
import amonov from '../img/amonov.jpg'

const Muallif = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <Button className='button' onClick={showModal}>
                Muallif
            </Button>
            <Modal
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}>
                <div className="muallifbox">
                    <img className='muallif muallif2' src={nuritov} alt="" />
                </div>
                <h3>IKROM RAJABOVICH NURITOV</h3>
                <h4> Milliy tadqiqot universiteti "Traktorlar va avtomobillar" kafedrasi dotsenti, texnika fanlari nomzodi</h4>
                <hr />

                <div className="muallifbox2">
                    <img className='muallif muallif2' src={amonov} alt="" />
                </div>
                <h3> MANSUR OCHILOVICH AMONOV</h3>
                <h4> Milliy tadqiqot universiteti "Traktorlar va avtomobillar" kafedrasi mudiri, dotsent </h4>
                <hr />

                <div className="muallifbox2">
                    <img className='muallif muallif2' src={uke} alt="" />
                </div>
                <h3>USMONOV KAMOLIDDIN ESHKULOVICH </h3>
                <h4> Milliy tadqiqot universitetining “Traktorlar va avtomobillar” kafedrasi dotsenti, texnika fanlari falsafa doktori </h4>
            </Modal>
        </>
    )
}

export default Muallif